import type { TFunction } from "i18next";
import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { ProcessingTimeResource } from "@exonn/js-sdk";

export const module: Module<ProcessingTimeResource> = {
  id: ResourceEnum.ProcessingTime,
  bigIcon: <i className={"icon-20-rights_profiles"} />, // icon-20-deliv_time
  smallIcon: <i className={"icon-15-rights_profiles"} />, // icon-15-deliv_time
  name: (t: TFunction) => t("moduleName.processing-time"),

  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
